import React from 'react';

export interface CardItem {
	title: string;
	txt: string;
	rssThumbmail?: string;
	isDeletable?: boolean;
	[key: string]: any;
}

interface CardProps {
	item: CardItem;
	setPreviewPost: (item: CardItem) => void;
}

export const Card: React.FC<CardProps> = (props) => {
	const { title, txt, rssThumbmail, isDeletable } = props.item;
	return (
		<>
			{!isDeletable && (
				<div
					className="post-tile p-2 gap-2 tile-head-display no-image"
					onClick={() => props.setPreviewPost(props.item)}
				>
					<div className="TileImage">
						<div
							className="post-image w-100"
							style={{ backgroundImage: `url(${rssThumbmail})` }}
						></div>
					</div>
					<div className="post-content">
						<div className="post-title font-bold">{title}</div>
						<div className="post-text mt-1">{txt}</div>
					</div>
				</div>
			)}
		</>
	);
};
